export default __webpack_public_path__ + "static/media/coffeeshop_3.8017c50d.png";